export default "__VITE_ASSET__DQV6KrHi__"